import React from 'react';
import PropTypes from 'prop-types';

import UserIconNew from "core/gd-ui/icon/user/user";

export default function ProjectUsersList(props){

    const usersToShow = 5;

    let res = [];
    let usersIds = _.map(gd.session.projectUsers.notClients(props.item.id), projectUser=>projectUser.user.id)

    usersIds = _.orderBy(usersIds, [
        id=>{
            let orderRes = 0;
            const user = props.item.users ? _.find(props.item.users, u=>u.id === id) : null;
            if (user) {
                switch (user.role) {
                    case gd.const.project.role.OWNER:           orderRes = 2; break;
                    case gd.const.project.role.PROJECT_MANAGER: orderRes = 1; break;
                }
            }
            return orderRes;
        },
        id=>gd.session.users.get(id).name.toLowerCase()
    ], ['desc','asc']);


    const isOpen = gd.const.systemStatus.isOpen(props.item.systemStatus);

    const userIcon = (id) =>
        <div key={id} className="ico">
            <UserIconNew className="user-icon" size="22" hint="up" userId={id} blackWhite={!isOpen}/>
        </div>

    if (usersIds.length > usersToShow) {
        usersIds.map(userId=>{
            if (res.length < (usersToShow-1)) res.push(userIcon(userId));
        });

        res.push(
            <div key="more" className="ico">
                <div className="ui5-counter circle-user">+{usersIds.length - (usersToShow-1)}</div>
            </div>
        )
    } else {
        usersIds.map(userId=>{res.push(userIcon(userId));});
    }

    return <div className="ui5-users-group">{res}</div>;
}

ProjectUsersList.propTypes = {
    item: PropTypes.object
}